import React, { createContext, useState, useContext } from "react";

const VerificaDesafioContext = createContext();

export default function AmbienteProvider({ children }) {
  const [verificaDesafio, setVerificaDesafio] = useState();

  return (
    <VerificaDesafioContext.Provider value={{ verificaDesafio, setVerificaDesafio }} >
      {children}
    </VerificaDesafioContext.Provider>
  );
}

export function useVerificaDesafioContext() {
  const context = useContext(VerificaDesafioContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { verificaDesafio, setVerificaDesafio } = context;
  return { verificaDesafio, setVerificaDesafio };
}

